import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { VerifikacijaComponent } from './verifikacija.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [VerifikacijaComponent],
  entryComponents: [VerifikacijaComponent],
  exports: [VerifikacijaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class VerifikacijaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/verifikacija/verifikacija.module.ts